import { render, staticRenderFns } from "./BeneUbicazione.vue?vue&type=template&id=6bcb85b7"
import script from "./BeneUbicazione.vue?vue&type=script&lang=ts"
export * from "./BeneUbicazione.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports